import { l as J } from "./lodash-5ofSKtz3.mjs";
import { j as V } from "./jsx-runtime-3tyXYecC.mjs";
import * as k from "react";
import { useRef as Ht, useMemo as Ne, useEffect as dt, useContext as ft, useState as Ke, isValidElement as yt, createElement as gt, createContext as qt } from "react";
import { C as Kt } from "./checkbox-DiWnVoeQ.mjs";
import { C as Jt } from "./checkbox-group-jz_F7j5y.mjs";
import { C as zt } from "./currency-picker-field-T3oPjf4m.mjs";
import { C as Xt } from "./currency-picker-provider-CTRNrW3S.mjs";
import { m as ht } from "./mui-DV6TgX2g.mjs";
import { c as Yt } from "./index-DkZ16bcJ.mjs";
import { B as me } from "./Box-B5hjovXR.mjs";
import { T as Pe } from "./text-field-ZOMRKQAY.mjs";
import { S as Qt } from "./section-header-Bma-sii2.mjs";
import { S as Zt } from "./select-field-BuE_t-Fz.mjs";
import { T as er } from "./text-area-CajlHzg4.mjs";
import { T as bt } from "./Typography-DfkimCSn.mjs";
import { S as tr } from "./sensitive-text-field-CgY8Ts9P.mjs";
import { D as rr } from "./date-picker-FVIC1w4I.mjs";
import { T as sr } from "./typography-Bj_iezxf.mjs";
import { i as nr } from "./transformSpacingProps-m0OnDuSS.mjs";
function pt(e, r) {
  return Array.isArray(e) ? e.includes(r) : typeof e == "object" ? r in e : !1;
}
const Ds = 1.25, Bs = {
  // Pixel heights
  teenie: 28,
  small: 32,
  medium: 34,
  large: 36,
  biggie: 42
}, Ts = {
  // used with theme spacing
  teenie: 0.875,
  small: 0.9375,
  medium: 0.625,
  large: 0.625,
  biggie: 1.315
}, Ns = {
  SSN: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
};
var re = (e) => e.type === "checkbox", ne = (e) => e instanceof Date, $ = (e) => e == null;
const xt = (e) => typeof e == "object";
var U = (e) => !$(e) && !Array.isArray(e) && xt(e) && !ne(e), ir = (e) => U(e) && e.target ? re(e.target) ? e.target.checked : e.target.value : e, mt = (e) => e.substring(0, e.search(/.\d/)) || e, Ft = (e, r) => [...e].some((t) => mt(r) === t), oe = (e) => e.filter(Boolean), R = (e) => e === void 0, m = (e, r, t) => {
  if (U(e) && r) {
    const s = oe(r.split(/[,[\].]+?/)).reduce((n, o) => $(n) ? n : n[o], e);
    return R(s) || s === e ? R(e[r]) ? t : e[r] : s;
  }
};
const De = {
  BLUR: "blur",
  CHANGE: "change"
}, z = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, X = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
var de = (e, r) => {
  const t = Object.assign({}, e);
  return delete t[r], t;
};
const vt = k.createContext(null), fe = () => k.useContext(vt), or = (e) => k.createElement(vt.Provider, { value: de(e, "children") }, e.children);
var _t = (e, r, t, s = !0) => {
  function n(a) {
    return () => {
      if (a in e)
        return r[a] !== z.all && (r[a] = !s || z.all), t && (t[a] = !0), e[a];
    };
  }
  const o = {};
  for (const a in e)
    Object.defineProperty(o, a, {
      get: n(a)
    });
  return o;
}, G = (e) => U(e) && !Object.keys(e).length, At = (e, r, t) => {
  const s = de(e, "name");
  return G(s) || Object.keys(s).length >= Object.keys(r).length || Object.keys(s).find((n) => r[n] === (!t || z.all));
}, W = (e) => Array.isArray(e) ? e : [e];
const wt = (e) => {
  e.current && (e.current.unsubscribe(), e.current = void 0);
}, ar = ({ _unsubscribe: e, props: r }) => () => {
  r.disabled ? wt(e) : e.current || (e.current = r.subject.subscribe({
    next: r.callback
  }));
};
function ye(e) {
  const r = k.useRef(), t = k.useRef(() => {
  });
  t.current = ar({
    _unsubscribe: r,
    props: e
  }), !e.skipEarlySubscription && t.current(), k.useEffect(() => (t.current(), () => wt(r)), []);
}
function cr(e) {
  const r = fe(), { control: t = r.control, disabled: s, name: n } = e || {}, [o, a] = k.useState(t._formState), d = k.useRef({
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), x = k.useRef(n);
  return x.current = n, ye({
    disabled: s,
    callback: (y) => (!x.current || !y.name || W(x.current).includes(y.name)) && At(y, d.current) && a(Object.assign(Object.assign({}, t._formState), y)),
    subject: t._subjects.state
  }), _t(o, t._proxyFormState, d.current, !1);
}
function ur(e) {
  const r = fe(), { name: t, control: s = r.control, shouldUnregister: n } = e, [o, a] = k.useState(m(s._formValues, t, m(s._defaultValues, t, e.defaultValue))), d = cr({
    control: s || r.control,
    name: t
  }), x = k.useRef(t);
  x.current = t, ye({
    subject: s._subjects.control,
    callback: (u) => (!u.name || x.current === u.name) && a(m(u.values, x.current))
  });
  const y = s.register(t, Object.assign(Object.assign({}, e.rules), { value: o })), f = k.useCallback((u, g) => {
    const _ = m(s._fields, u);
    _ && (_._f.mount = g);
  }, [s]);
  return k.useEffect(() => (f(t, !0), () => {
    const u = s._options.shouldUnregister || n;
    (Ft(s._names.array, t) ? u && !s._stateFlags.action : u) ? s.unregister(t) : f(t, !1);
  }), [t, s, n, f]), {
    field: {
      onChange: (u) => {
        const g = ir(u);
        a(g), y.onChange({
          target: {
            value: g,
            name: t
          },
          type: De.CHANGE
        });
      },
      onBlur: () => {
        y.onBlur({
          target: {
            value: o,
            name: t
          },
          type: De.BLUR
        });
      },
      name: t,
      value: o,
      ref: (u) => {
        const g = m(s._fields, t);
        u && g && u.focus && (g._f.ref = {
          focus: () => u.focus(),
          setCustomValidity: (_) => u.setCustomValidity(_),
          reportValidity: () => u.reportValidity()
        });
      }
    },
    formState: d,
    fieldState: {
      invalid: !!m(d.errors, t),
      isDirty: !!m(d.dirtyFields, t),
      isTouched: !!m(d.touchedFields, t),
      error: m(d.errors, t)
    }
  };
}
const lr = (e) => e.render(ur(e));
var dr = (e, r, t, s, n) => r ? Object.assign(Object.assign({}, t[e]), { types: Object.assign(Object.assign({}, t[e] && t[e].types ? t[e].types : {}), { [s]: n || !0 }) }) : {}, kt = (e) => /^\w*$/.test(e), St = (e) => oe(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function O(e, r, t) {
  let s = -1;
  const n = kt(r) ? [r] : St(r), o = n.length, a = o - 1;
  for (; ++s < o; ) {
    const d = n[s];
    let x = t;
    if (s !== a) {
      const y = e[d];
      x = U(y) || Array.isArray(y) ? y : isNaN(+n[s + 1]) ? {} : [];
    }
    e[d] = x, e = e[d];
  }
  return e;
}
const xe = (e, r, t) => {
  for (const s of t || Object.keys(e)) {
    const n = m(e, s);
    if (n) {
      const o = n._f, a = de(n, "_f");
      if (o && r(o.name)) {
        if (o.ref.focus && R(o.ref.focus()))
          break;
        if (o.refs) {
          o.refs[0].focus();
          break;
        }
      } else U(a) && xe(a, r);
    }
  }
};
var Ve = (e, r, t = {}) => t.shouldFocus || R(t.shouldFocus) ? t.focusName || `${e}.${R(t.focusIndex) ? r : t.focusIndex}.` : "", ee = (e, r, t) => e.map((s, n) => {
  const o = r.current[n];
  return Object.assign(Object.assign({}, s), o ? { [t]: o[t] } : {});
}), fr = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    const t = (Math.random() * 16 + e) % 16 | 0;
    return (r == "x" ? t : t & 3 | 8).toString(16);
  });
}, te = (e = [], r) => e.map((t) => Object.assign(Object.assign({}, t[r] ? {} : { [r]: fr() }), t));
function Je(e, r) {
  return [...W(e), ...W(r)];
}
var Oe = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function ze(e, r, t) {
  return [
    ...e.slice(0, r),
    ...W(t),
    ...e.slice(r)
  ];
}
var Xe = (e, r, t) => Array.isArray(e) ? (R(e[t]) && (e[t] = void 0), e.splice(t, 0, e.splice(r, 1)[0]), e) : [], yr = (e, r) => e.map((t = {}) => de(t, r));
function Ye(e, r) {
  return [...W(r), ...W(e)];
}
function gr(e, r) {
  let t = 0;
  const s = [...e];
  for (const n of r)
    s.splice(n - t, 1), t++;
  return oe(s).length ? s : [];
}
var Qe = (e, r) => R(r) ? [] : gr(e, W(r).sort((t, s) => t - s)), Ze = (e, r, t) => {
  e[r] = [e[t], e[t] = e[r]][0];
}, et = (e, r, t) => (e[r] = t, e);
const Ps = (e) => {
  const r = fe(), { control: t = r.control, name: s, keyName: n = "id", shouldUnregister: o } = e, [a, d] = k.useState(te(t._getFieldArray(s), n)), x = k.useRef(a), y = k.useRef(s);
  y.current = s, x.current = a, t._names.array.add(s), ye({
    callback: ({ values: F, name: w }) => {
      (w === y.current || !w) && d(te(m(F, y.current), n));
    },
    subject: t._subjects.array,
    skipEarlySubscription: !0
  });
  const f = k.useCallback((F) => {
    const w = yr(F, n);
    return O(t._formValues, s, w), d(F), w;
  }, [t, s, n]), u = (F, w) => {
    const C = W(F), B = Je(ee(t._getFieldArray(s), x, n), te(C, n));
    t._updateFieldArray(s, Je, {
      argA: Oe(F)
    }, f(B)), t._names.focus = Ve(s, B.length - C.length, w);
  }, g = (F, w) => {
    const C = Ye(ee(t._getFieldArray(s), x, n), te(W(F), n));
    t._updateFieldArray(s, Ye, {
      argA: Oe(F)
    }, f(C)), t._names.focus = Ve(s, 0, w);
  }, _ = (F) => {
    const w = Qe(ee(t._getFieldArray(s), x, n), F);
    t._updateFieldArray(s, Qe, {
      argA: F
    }, f(w));
  }, I = (F, w, C) => {
    const B = ze(ee(t._getFieldArray(s), x, n), F, te(W(w), n));
    t._updateFieldArray(s, ze, {
      argA: F,
      argB: Oe(w)
    }, f(B)), t._names.focus = Ve(s, F, C);
  }, L = (F, w) => {
    const C = ee(t._getFieldArray(s), x, n);
    Ze(C, F, w), t._updateFieldArray(s, Ze, {
      argA: F,
      argB: w
    }, f(C), !1);
  }, K = (F, w) => {
    const C = ee(t._getFieldArray(s), x, n);
    Xe(C, F, w), t._updateFieldArray(s, Xe, {
      argA: F,
      argB: w
    }, f(C), !1);
  }, M = (F, w) => {
    const C = ee(t._getFieldArray(s), x, n), B = et(C, F, w);
    x.current = te(B, n), t._updateFieldArray(s, et, {
      argA: F,
      argB: w
    }, f(x.current), !0, !1);
  }, D = (F) => {
    const w = te(W(F), n);
    t._updateFieldArray(s, () => w, {}, f(w), !0, !1);
  };
  return k.useEffect(() => {
    if (t._stateFlags.action = !1, t._names.watchAll)
      t._subjects.state.next({});
    else
      for (const F of t._names.watch)
        if (s.startsWith(F)) {
          t._subjects.state.next({});
          break;
        }
    t._subjects.watch.next({
      name: s,
      values: t._formValues
    }), t._names.focus && xe(t._fields, (F) => F.startsWith(t._names.focus)), t._names.focus = "", t._proxyFormState.isValid && t._updateValid();
  }, [a, s, t, n]), k.useEffect(() => (!m(t._formValues, s) && O(t._formValues, s, []), () => {
    (t._options.shouldUnregister || o) && t.unregister(s);
  }), [s, t, n, o]), {
    swap: k.useCallback(L, [f, s, t, n]),
    move: k.useCallback(K, [f, s, t, n]),
    prepend: k.useCallback(g, [f, s, t, n]),
    append: k.useCallback(u, [f, s, t, n]),
    remove: k.useCallback(_, [f, s, t, n]),
    insert: k.useCallback(I, [f, s, t, n]),
    update: k.useCallback(M, [f, s, t, n]),
    replace: k.useCallback(D, [f, s, t, n]),
    fields: a
  };
};
var We = (e) => typeof e == "function";
function Be(e) {
  let r;
  const t = Array.isArray(e);
  if (e instanceof Date)
    r = new Date(e);
  else if (e instanceof Set)
    r = new Set(e);
  else if (t || U(e)) {
    r = t ? [] : {};
    for (const s in e) {
      if (We(e[s])) {
        r = e;
        break;
      }
      r[s] = Be(e[s]);
    }
  } else
    return e;
  return r;
}
var le = (e) => $(e) || !xt(e);
function ie(e, r) {
  if (le(e) || le(r))
    return e === r;
  if (ne(e) && ne(r))
    return e.getTime() === r.getTime();
  const t = Object.keys(e), s = Object.keys(r);
  if (t.length !== s.length)
    return !1;
  for (const n of t) {
    const o = e[n];
    if (!s.includes(n))
      return !1;
    if (n !== "ref") {
      const a = r[n];
      if (ne(o) && ne(a) || U(o) && U(a) || Array.isArray(o) && Array.isArray(a) ? !ie(o, a) : o !== a)
        return !1;
    }
  }
  return !0;
}
var tt = (e) => ({
  isOnSubmit: !e || e === z.onSubmit,
  isOnBlur: e === z.onBlur,
  isOnChange: e === z.onChange,
  isOnAll: e === z.all,
  isOnTouch: e === z.onTouched
}), ae = (e) => typeof e == "boolean", be = (e) => e instanceof HTMLElement, jt = (e) => e.type === "select-multiple", Ie = (e) => e.type === "radio", hr = (e) => Ie(e) || re(e), Y = (e) => typeof e == "string", rt = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u", st = (e) => !be(e) || !document.contains(e);
class br {
  constructor() {
    this.tearDowns = [];
  }
  add(r) {
    this.tearDowns.push(r);
  }
  unsubscribe() {
    for (const r of this.tearDowns)
      r();
    this.tearDowns = [];
  }
}
class pr {
  constructor(r, t) {
    this.observer = r, this.closed = !1, t.add(() => this.closed = !0);
  }
  next(r) {
    this.closed || this.observer.next(r);
  }
}
class he {
  constructor() {
    this.observers = [];
  }
  next(r) {
    for (const t of this.observers)
      t.next(r);
  }
  subscribe(r) {
    const t = new br(), s = new pr(r, t);
    return this.observers.push(s), t;
  }
  unsubscribe() {
    this.observers = [];
  }
}
function xr(e, r) {
  const t = r.slice(0, -1).length;
  let s = 0;
  for (; s < t; )
    e = R(e) ? s++ : e[r[s++]];
  return e;
}
function q(e, r) {
  const t = kt(r) ? [r] : St(r), s = t.length == 1 ? e : xr(e, t), n = t[t.length - 1];
  let o;
  s && delete s[n];
  for (let a = 0; a < t.slice(0, -1).length; a++) {
    let d = -1, x;
    const y = t.slice(0, -(a + 1)), f = y.length - 1;
    for (a > 0 && (o = e); ++d < y.length; ) {
      const u = y[d];
      x = x ? x[u] : e[u], f === d && (U(x) && G(x) || Array.isArray(x) && !x.filter((g) => U(g) && !G(g) || ae(g)).length) && (o ? delete o[u] : delete e[u]), o = x;
    }
  }
  return e;
}
var Vt = (e) => e.type === "file";
const nt = {
  value: !1,
  isValid: !1
}, it = { value: !0, isValid: !0 };
var Ot = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const r = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: r, isValid: !!r.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !R(e[0].attributes.value) ? R(e[0].value) || e[0].value === "" ? it : { value: e[0].value, isValid: !0 } : it
    ) : nt;
  }
  return nt;
}, Ct = (e, { valueAsNumber: r, valueAsDate: t, setValueAs: s }) => R(e) ? e : r ? e === "" ? NaN : +e : t ? new Date(e) : s ? s(e) : e;
const ot = {
  isValid: !1,
  value: null
};
var Et = (e) => Array.isArray(e) ? e.reduce((r, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : r, ot) : ot;
function Ce(e) {
  const r = e.ref;
  if (!(e.refs ? e.refs.every((t) => t.disabled) : r.disabled))
    return Vt(r) ? r.files : Ie(r) ? Et(e.refs).value : jt(r) ? [...r.selectedOptions].map(({ value: t }) => t) : re(r) ? Ot(e.refs).value : Ct(R(r.value) ? e.ref.value : r.value, e);
}
var mr = (e, r, t, s) => {
  const n = {};
  for (const o of e) {
    const a = m(r, o);
    a && O(n, o, a._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: n,
    shouldUseNativeValidation: s
  };
}, Fr = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Rt(e, r) {
  if (le(e) || le(r))
    return r;
  for (const t in r) {
    const s = e[t], n = r[t];
    try {
      e[t] = U(s) && U(n) || Array.isArray(s) && Array.isArray(n) ? Rt(s, n) : n;
    } catch {
    }
  }
  return e;
}
function Te(e, r, t, s, n) {
  let o = -1;
  for (; ++o < e.length; ) {
    for (const a in e[o])
      Array.isArray(e[o][a]) ? (!t[o] && (t[o] = {}), t[o][a] = [], Te(e[o][a], m(r[o] || {}, a, []), t[o][a], t[o], a)) : !$(r) && ie(m(r[o] || {}, a), e[o][a]) ? O(t[o] || {}, a) : t[o] = Object.assign(Object.assign({}, t[o]), { [a]: !0 });
    s && !t.length && delete s[n];
  }
  return t;
}
var vr = (e, r, t) => Rt(Te(e, r, t.slice(0, e.length)), Te(r, e, t.slice(0, e.length))), _r = (e, r, t, s, n) => n.isOnAll ? !1 : !t && n.isOnTouch ? !(r || e) : (t ? s.isOnBlur : n.isOnBlur) ? !e : (t ? s.isOnChange : n.isOnChange) ? e : !0, Ee = (e, r) => !oe(m(e, r, [])).length && q(e, r), pe = (e) => Y(e) || k.isValidElement(e), Dt = (e) => e instanceof RegExp;
function at(e, r, t = "validate") {
  if (pe(e) || Array.isArray(e) && e.every(pe) || ae(e) && !e)
    return {
      type: t,
      message: pe(e) ? e : "",
      ref: r
    };
}
var se = (e) => U(e) && !Dt(e) ? e : {
  value: e,
  message: ""
}, ct = async (e, r, t, s) => {
  const { ref: n, refs: o, required: a, maxLength: d, minLength: x, min: y, max: f, pattern: u, validate: g, name: _, valueAsNumber: I, mount: L, disabled: K } = e._f;
  if (!L || K)
    return {};
  const M = o ? o[0] : n, D = (j) => {
    s && M.reportValidity && (M.setCustomValidity(ae(j) ? "" : j || " "), M.reportValidity());
  }, F = {}, w = Ie(n), C = re(n), B = w || C, N = (I || Vt(n)) && !n.value || r === "" || Array.isArray(r) && !r.length, Q = dr.bind(null, _, t, F), Z = (j, S, T, P = X.maxLength, H = X.minLength) => {
    const ge = j ? S : T;
    F[_] = Object.assign({
      type: j ? P : H,
      message: ge,
      ref: n
    }, Q(j ? P : H, ge));
  };
  if (a && (!B && (N || $(r)) || ae(r) && !r || C && !Ot(o).isValid || w && !Et(o).isValid)) {
    const { value: j, message: S } = pe(a) ? { value: !!a, message: a } : se(a);
    if (j && (F[_] = Object.assign({ type: X.required, message: S, ref: M }, Q(X.required, S)), !t))
      return D(S), F;
  }
  if (!N && (!$(y) || !$(f))) {
    let j, S;
    const T = se(f), P = se(y);
    if (isNaN(r)) {
      const H = n.valueAsDate || new Date(r);
      Y(T.value) && (j = H > new Date(T.value)), Y(P.value) && (S = H < new Date(P.value));
    } else {
      const H = n.valueAsNumber || parseFloat(r);
      $(T.value) || (j = H > T.value), $(P.value) || (S = H < P.value);
    }
    if ((j || S) && (Z(!!j, T.message, P.message, X.max, X.min), !t))
      return D(F[_].message), F;
  }
  if ((d || x) && !N && Y(r)) {
    const j = se(d), S = se(x), T = !$(j.value) && r.length > j.value, P = !$(S.value) && r.length < S.value;
    if ((T || P) && (Z(T, j.message, S.message), !t))
      return D(F[_].message), F;
  }
  if (u && !N && Y(r)) {
    const { value: j, message: S } = se(u);
    if (Dt(j) && !r.match(j) && (F[_] = Object.assign({
      type: X.pattern,
      message: S,
      ref: n
    }, Q(X.pattern, S)), !t))
      return D(S), F;
  }
  if (g) {
    if (We(g)) {
      const j = await g(r), S = at(j, M);
      if (S && (F[_] = Object.assign(Object.assign({}, S), Q(X.validate, S.message)), !t))
        return D(S.message), F;
    } else if (U(g)) {
      let j = {};
      for (const S in g) {
        if (!G(j) && !t)
          break;
        const T = at(await g[S](r), M, S);
        T && (j = Object.assign(Object.assign({}, T), Q(S, T.message)), D(T.message), t && (F[_] = j));
      }
      if (!G(j) && (F[_] = Object.assign({ ref: M }, j), !t))
        return F;
    }
  }
  return D(!0), F;
};
const Ar = {
  mode: z.onSubmit,
  reValidateMode: z.onChange,
  shouldFocusError: !0
}, wr = typeof window > "u";
function kr(e = {}) {
  let r = Object.assign(Object.assign({}, Ar), e), t = {
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    errors: {}
  }, s = {}, n = r.defaultValues || {}, o = r.shouldUnregister ? {} : Be(n), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, d = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, x, y = 0, f = {};
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, g = {
    watch: new he(),
    control: new he(),
    array: new he(),
    state: new he()
  }, _ = tt(r.mode), I = tt(r.reValidateMode), L = r.criteriaMode === z.all, K = (i, c) => (...l) => {
    clearTimeout(y), y = window.setTimeout(() => i(...l), c);
  }, M = (i, c) => !c && (d.watchAll || d.watch.has(i) || d.watch.has((i.match(/\w+/) || [])[0])), D = async (i) => {
    let c = !1;
    return u.isValid && (c = r.resolver ? G((await Z()).errors) : await S(s, !0), !i && c !== t.isValid && (t.isValid = c, g.state.next({
      isValid: c
    }))), c;
  }, F = (i, c, l, b = [], p = !0, h = !0) => {
    if (a.action = !0, h && m(s, i)) {
      const v = c(m(s, i), l.argA, l.argB);
      p && O(s, i, v);
    }
    if (Array.isArray(m(t.errors, i))) {
      const v = c(m(t.errors, i), l.argA, l.argB);
      p && O(t.errors, i, v), Ee(t.errors, i);
    }
    if (u.touchedFields && m(t.touchedFields, i)) {
      const v = c(m(t.touchedFields, i), l.argA, l.argB);
      p && O(t.touchedFields, i, v), Ee(t.touchedFields, i);
    }
    (u.dirtyFields || u.isDirty) && N(i, b), g.state.next({
      isDirty: P(i, b),
      dirtyFields: t.dirtyFields,
      errors: t.errors,
      isValid: t.isValid
    });
  }, w = (i, c) => (O(t.errors, i, c), g.state.next({
    errors: t.errors
  })), C = (i, c, l) => {
    const b = m(s, i);
    if (b) {
      const p = m(o, i, m(n, i));
      R(p) || l && l.defaultChecked || c ? O(o, i, c ? p : Ce(b._f)) : Fe(i, p);
    }
    a.mount && D();
  }, B = (i, c, l, b = !0) => {
    let p = !1;
    const h = {
      name: i
    }, v = m(t.touchedFields, i);
    if (u.isDirty) {
      const A = t.isDirty;
      t.isDirty = h.isDirty = P(), p = A !== h.isDirty;
    }
    if (u.dirtyFields && !l) {
      const A = m(t.dirtyFields, i);
      ie(m(n, i), c) ? q(t.dirtyFields, i) : O(t.dirtyFields, i, !0), h.dirtyFields = t.dirtyFields, p = p || A !== m(t.dirtyFields, i);
    }
    return l && !v && (O(t.touchedFields, i, l), h.touchedFields = t.touchedFields, p = p || u.touchedFields && v !== l), p && b && g.state.next(h), p ? h : {};
  }, N = (i, c) => (O(t.dirtyFields, i, vr(c, m(n, i, []), m(t.dirtyFields, i, []))), Ee(t.dirtyFields, i)), Q = async (i, c, l, b, p) => {
    const h = m(t.errors, c), v = u.isValid && t.isValid !== l;
    if (e.delayError && b ? (x = x || K(w, e.delayError), x(c, b)) : (clearTimeout(y), b ? O(t.errors, c, b) : q(t.errors, c)), ((b ? !ie(h, b) : h) || !G(p) || v) && !i) {
      const A = Object.assign(Object.assign(Object.assign({}, p), v ? { isValid: l } : {}), { errors: t.errors, name: c });
      t = Object.assign(Object.assign({}, t), A), g.state.next(A);
    }
    f[c]--, u.isValidating && !f[c] && (g.state.next({
      isValidating: !1
    }), f = {});
  }, Z = async (i) => r.resolver ? await r.resolver(Object.assign({}, o), r.context, mr(i || d.mount, s, r.criteriaMode, r.shouldUseNativeValidation)) : {}, j = async (i) => {
    const { errors: c } = await Z();
    if (i)
      for (const l of i) {
        const b = m(c, l);
        b ? O(t.errors, l, b) : q(t.errors, l);
      }
    else
      t.errors = c;
    return c;
  }, S = async (i, c, l = {
    valid: !0
  }) => {
    for (const b in i) {
      const p = i[b];
      if (p) {
        const h = p._f, v = de(p, "_f");
        if (h) {
          const A = await ct(p, m(o, h.name), L, r.shouldUseNativeValidation);
          if (A[h.name] && (l.valid = !1, c))
            break;
          c || (A[h.name] ? O(t.errors, h.name, A[h.name]) : q(t.errors, h.name));
        }
        v && await S(v, c, l);
      }
    }
    return l.valid;
  }, T = () => {
    for (const i of d.unMount) {
      const c = m(s, i);
      c && (c._f.refs ? c._f.refs.every(st) : st(c._f.ref)) && _e(i);
    }
    d.unMount = /* @__PURE__ */ new Set();
  }, P = (i, c) => (i && c && O(o, i, c), !ie(He(), n)), H = (i, c, l) => {
    const b = Object.assign({}, a.mount ? o : R(c) ? n : Y(i) ? { [i]: c } : c);
    if (i) {
      const p = W(i).map((h) => (l && d.watch.add(h), m(b, h)));
      return Array.isArray(i) ? p : p[0];
    }
    return l && (d.watchAll = !0), b;
  }, ge = (i) => m(a.mount ? o : n, i, []), Fe = (i, c, l = {}, b) => {
    const p = m(s, i);
    let h = c;
    if (p) {
      const v = p._f;
      v && (O(o, i, Ct(c, v)), h = rt && be(v.ref) && $(c) ? "" : c, jt(v.ref) ? [...v.ref.options].forEach((A) => A.selected = h.includes(A.value)) : v.refs ? re(v.ref) ? v.refs.length > 1 ? v.refs.forEach((A) => A.checked = Array.isArray(h) ? !!h.find((ce) => ce === A.value) : h === A.value) : v.refs[0].checked = !!h : v.refs.forEach((A) => A.checked = A.value === h) : v.ref.value = h, b && g.control.next({
        values: o,
        name: i
      }));
    }
    (l.shouldDirty || l.shouldTouch) && B(i, h, l.shouldTouch), l.shouldValidate && ve(i);
  }, Ge = (i, c, l) => {
    for (const b in c) {
      const p = c[b], h = `${i}.${b}`, v = m(s, h);
      (d.array.has(i) || !le(p) || v && !v._f) && !ne(p) ? Ge(h, p, l) : Fe(h, p, l, !0);
    }
  }, Mt = (i, c, l = {}) => {
    const b = m(s, i), p = d.array.has(i);
    O(o, i, c), p ? (g.array.next({
      name: i,
      values: o
    }), (u.isDirty || u.dirtyFields) && l.shouldDirty && (N(i, c), g.state.next({
      name: i,
      dirtyFields: t.dirtyFields,
      isDirty: P(i, c)
    }))) : b && !b._f && !$(c) ? Ge(i, c, l) : Fe(i, c, l, !0), M(i) && g.state.next({}), g.watch.next({
      name: i
    });
  }, $e = async (i) => {
    const c = i.target;
    let l = c.name;
    const b = m(s, l);
    if (b) {
      let p, h;
      const v = c.type ? Ce(b._f) : c.value, A = i.type === De.BLUR, ce = !Fr(b._f) && !r.resolver && !m(t.errors, l) && !b._f.deps || _r(A, m(t.touchedFields, l), t.isSubmitted, I, _), we = M(l, A);
      A ? b._f.onBlur && b._f.onBlur(i) : b._f.onChange && b._f.onChange(i), O(o, l, v);
      const ke = B(l, v, A, !1), $t = !G(ke) || we;
      if (!A && g.watch.next({
        name: l,
        type: i.type
      }), ce)
        return $t && g.state.next(Object.assign({ name: l }, we ? {} : ke));
      if (!A && we && g.state.next({}), f[l] = (f[l], 1), u.isValidating && g.state.next({
        isValidating: !0
      }), r.resolver) {
        const { errors: Se } = await Z([l]);
        if (p = m(Se, l), re(c) && !p) {
          const je = mt(l), qe = m(s, je);
          if (Array.isArray(qe) && qe.every((ue) => ue._f && re(ue._f.ref))) {
            const ue = m(Se, je, {});
            ue.type && (p = ue), l = je;
          }
        }
        h = G(Se);
      } else
        p = (await ct(b, m(o, l), L, r.shouldUseNativeValidation))[l], h = await D(!0);
      b._f.deps && ve(b._f.deps), Q(!1, l, h, p, ke);
    }
  }, ve = async (i, c = {}) => {
    let l, b;
    const p = W(i);
    if (g.state.next({
      isValidating: !0
    }), r.resolver) {
      const h = await j(R(i) ? i : p);
      l = G(h), b = i ? !p.some((v) => m(h, v)) : l;
    } else i ? (b = (await Promise.all(p.map(async (h) => {
      const v = m(s, h);
      return await S(v && v._f ? { [h]: v } : v);
    }))).every(Boolean), D()) : b = l = await S(s);
    return g.state.next(Object.assign(Object.assign({}, !Y(i) || l !== t.isValid ? {} : { name: i }), { errors: t.errors, isValid: l, isValidating: !1 })), c.shouldFocus && !b && xe(s, (h) => m(t.errors, h), i ? p : d.mount), b;
  }, He = (i) => {
    const c = Object.assign(Object.assign({}, n), a.mount ? o : {});
    return R(i) ? c : Y(i) ? m(c, i) : i.map((l) => m(c, l));
  }, Ut = (i) => {
    i ? W(i).forEach((c) => q(t.errors, c)) : t.errors = {}, g.state.next({
      errors: t.errors
    });
  }, Lt = (i, c, l) => {
    const b = (m(s, i, { _f: {} })._f || {}).ref;
    O(t.errors, i, Object.assign(Object.assign({}, c), { ref: b })), g.state.next({
      name: i,
      errors: t.errors,
      isValid: !1
    }), l && l.shouldFocus && b && b.focus && b.focus();
  }, Gt = (i, c) => We(i) ? g.watch.subscribe({
    next: (l) => i(H(void 0, c), l)
  }) : H(i, c, !0), _e = (i, c = {}) => {
    for (const l of i ? W(i) : d.mount)
      d.mount.delete(l), d.array.delete(l), m(s, l) && (c.keepValue || (q(s, l), q(o, l)), !c.keepError && q(t.errors, l), !c.keepDirty && q(t.dirtyFields, l), !c.keepTouched && q(t.touchedFields, l), !r.shouldUnregister && !c.keepDefaultValue && q(n, l));
    g.watch.next({}), g.state.next(Object.assign(Object.assign({}, t), c.keepDirty ? { isDirty: P() } : {})), !c.keepIsValid && D();
  }, Ae = (i, c = {}) => {
    const l = m(s, i);
    return O(s, i, {
      _f: Object.assign(Object.assign(Object.assign({}, l && l._f ? l._f : { ref: { name: i } }), { name: i, mount: !0 }), c)
    }), d.mount.add(i), !R(c.value) && O(o, i, c.value), l ? ae(c.disabled) && O(o, i, c.disabled ? void 0 : m(o, i, Ce(l._f))) : C(i, !0), wr ? { name: i } : Object.assign(Object.assign({ name: i }, ae(c.disabled) ? { disabled: c.disabled } : {}), { onChange: $e, onBlur: $e, ref: (b) => {
      if (b) {
        Ae(i, c);
        let p = m(s, i);
        const h = R(b.value) && b.querySelectorAll && b.querySelectorAll("input,select,textarea")[0] || b, v = hr(h);
        if (h === p._f.ref || v && oe(p._f.refs || []).find((A) => A === h))
          return;
        p = {
          _f: v ? Object.assign(Object.assign({}, p._f), { refs: [
            ...oe(p._f.refs || []).filter((A) => be(A) && document.contains(A)),
            h
          ], ref: { type: h.type, name: i } }) : Object.assign(Object.assign({}, p._f), { ref: h })
        }, O(s, i, p), (!c || !c.disabled) && C(i, !1, h);
      } else {
        const p = m(s, i, {}), h = r.shouldUnregister || c.shouldUnregister;
        p._f && (p._f.mount = !1), h && !(Ft(d.array, i) && a.action) && d.unMount.add(i);
      }
    } });
  };
  return {
    control: {
      register: Ae,
      unregister: _e,
      _getWatch: H,
      _getDirty: P,
      _updateValid: D,
      _removeUnmounted: T,
      _updateFieldArray: F,
      _getFieldArray: ge,
      _subjects: g,
      _proxyFormState: u,
      get _fields() {
        return s;
      },
      set _fields(i) {
        s = i;
      },
      get _formValues() {
        return o;
      },
      set _formValues(i) {
        o = i;
      },
      get _stateFlags() {
        return a;
      },
      set _stateFlags(i) {
        a = i;
      },
      get _defaultValues() {
        return n;
      },
      set _defaultValues(i) {
        n = i;
      },
      get _names() {
        return d;
      },
      set _names(i) {
        d = i;
      },
      get _formState() {
        return t;
      },
      set _formState(i) {
        t = i;
      },
      get _options() {
        return r;
      },
      set _options(i) {
        r = Object.assign(Object.assign({}, r), i);
      }
    },
    trigger: ve,
    register: Ae,
    handleSubmit: (i, c) => async (l) => {
      l && (l.preventDefault && l.preventDefault(), l.persist && l.persist());
      let b = !0, p = Object.assign({}, o);
      g.state.next({
        isSubmitting: !0
      });
      try {
        if (r.resolver) {
          const { errors: h, values: v } = await Z();
          t.errors = h, p = v;
        } else
          await S(s);
        G(t.errors) && Object.keys(t.errors).every((h) => m(p, h)) ? (g.state.next({
          errors: {},
          isSubmitting: !0
        }), await i(p, l)) : (c && await c(t.errors, l), r.shouldFocusError && xe(s, (h) => m(t.errors, h), d.mount));
      } catch (h) {
        throw b = !1, h;
      } finally {
        t.isSubmitted = !0, g.state.next({
          isSubmitted: !0,
          isSubmitting: !1,
          isSubmitSuccessful: G(t.errors) && b,
          submitCount: t.submitCount + 1,
          errors: t.errors
        });
      }
    },
    watch: Gt,
    setValue: Mt,
    getValues: He,
    reset: (i, c = {}) => {
      const l = !G(i), b = i || n, p = Be(b);
      if (c.keepDefaultValues || (n = b), !c.keepValues) {
        if (rt)
          for (const h of d.mount) {
            const v = m(s, h);
            if (v && v._f) {
              const A = Array.isArray(v._f.refs) ? v._f.refs[0] : v._f.ref;
              try {
                be(A) && A.closest("form").reset();
                break;
              } catch {
              }
            }
          }
        o = e.shouldUnregister ? {} : p, s = {}, g.control.next({
          values: l ? p : n
        }), g.watch.next({}), g.array.next({
          values: p
        });
      }
      d = {
        mount: /* @__PURE__ */ new Set(),
        unMount: /* @__PURE__ */ new Set(),
        array: /* @__PURE__ */ new Set(),
        watch: /* @__PURE__ */ new Set(),
        watchAll: !1,
        focus: ""
      }, g.state.next({
        submitCount: c.keepSubmitCount ? t.submitCount : 0,
        isDirty: c.keepDirty ? t.isDirty : c.keepDefaultValues ? ie(i, n) : !1,
        isSubmitted: c.keepIsSubmitted ? t.isSubmitted : !1,
        dirtyFields: c.keepDirty ? t.dirtyFields : {},
        touchedFields: c.keepTouched ? t.touchedFields : {},
        errors: c.keepErrors ? t.errors : {},
        isSubmitting: !1,
        isSubmitSuccessful: !1
      }), a.mount = !u.isValid || !!c.keepIsValid, a.watch = !!e.shouldUnregister;
    },
    clearErrors: Ut,
    unregister: _e,
    setError: Lt,
    setFocus: (i) => m(s, i)._f.ref.focus()
  };
}
function Sr(e = {}) {
  const r = k.useRef(), [t, s] = k.useState({
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    errors: {}
  });
  r.current ? r.current.control._options = e : r.current = Object.assign(Object.assign({}, kr(e)), { formState: t });
  const n = r.current.control;
  return ye({
    subject: n._subjects.state,
    callback: (o) => {
      At(o, n._proxyFormState, !0) && (n._formState = Object.assign(Object.assign({}, n._formState), o), s(Object.assign({}, n._formState)));
    }
  }), k.useEffect(() => {
    n._stateFlags.mount || (n._proxyFormState.isValid && n._updateValid(), n._stateFlags.mount = !0), n._stateFlags.watch && (n._stateFlags.watch = !1, n._subjects.state.next({})), n._removeUnmounted();
  }), r.current.formState = _t(t, n._proxyFormState), r.current;
}
function Ws(e) {
  const r = fe(), { control: t = r.control, name: s, defaultValue: n, disabled: o } = e || {}, a = k.useRef(s);
  a.current = s, ye({
    disabled: o,
    subject: t._subjects.watch,
    callback: ({ name: y }) => {
      if (!a.current || !y || W(a.current).some((f) => y && f && (y.startsWith(f) || f.startsWith(y)))) {
        t._stateFlags.mount = !0;
        const f = t._getWatch(a.current, n);
        x(U(f) ? Object.assign({}, f) : Array.isArray(f) ? [...f] : f);
      }
    }
  });
  const [d, x] = k.useState(R(n) ? t._getWatch(s) : n);
  return k.useEffect(() => {
    t._removeUnmounted();
  }), d;
}
const jr = (e) => typeof e == "boolean" ? {
  checked: e
} : typeof e == "object" ? e : { value: e }, Vr = (e, r, t) => (s, ...n) => {
  var o, a;
  if (t) {
    const d = [...n, r];
    return e(t(s, ...d));
  }
  if (!s) return e(s);
  if (s.hasOwnProperty("target"))
    return (o = s.target) != null && o.hasOwnProperty("checked") ? e(s.target.checked) : e((a = s.target) == null ? void 0 : a.value);
  if (s.hasOwnProperty("checked"))
    return e(s.checked);
  if (s.hasOwnProperty("value"))
    return e(s.value);
  e(s);
}, Or = (e) => (r, { isControlled: t, rules: s = {}, defaultValue: n = "", name: o, ...a }) => {
  if (!t)
    return /* @__PURE__ */ V.jsxs(bt, { color: "error", variant: "caption", children: [
      o,
      " was not registered as a controlledField"
    ] });
  const { setValueAs: d, ...x } = s;
  return /* @__PURE__ */ V.jsx(
    lr,
    {
      control: e,
      defaultValue: n,
      name: o,
      render: ({ field: y }) => {
        const f = jr(y.value), u = Vr(y.onChange, y.value, d), g = () => y.onBlur();
        g.__fabricInternalOnlySupressBlur = !0;
        const _ = { ...a, ...y, ...f, name: o, onBlur: g, onChange: u };
        return r(_);
      },
      rules: x
    },
    o
  );
}, Cr = (e) => {
  if (e !== !1)
    return e === !0 ? "Required" : e;
}, Bt = (e, r, t) => {
  const [s, ...n] = r;
  return n.length === 0 ? e[s] = t : (e[s] || (e[s] = isNaN(n[0]) ? {} : []), e[s] = Bt(e[s], n, t)), e;
}, Me = (e, r, t = {}) => e.reduce((s, { name: n, autoRegister: o, required: a, maxLength: d, validate: x, setValueAs: y, ...f }) => {
  const u = { maxLength: d, validate: x, setValueAs: y }, g = {};
  a && (u.required = Cr(a), g.required = !0);
  const _ = o ? r(n, u) : { isControlled: !0, rules: u };
  return Bt(s, n.split("."), {
    ...f,
    ..._,
    ...g,
    name: n
  });
}, t), Er = (e, r) => {
  const t = Me([e], r);
  return J.get(t, e.name);
}, Rr = (e, r) => {
  const t = Sr(r), { register: s, control: n } = t, o = Ht([]);
  J.isEqual(o.current, e) || (o.current = e);
  const a = Ne(() => !e || e.length === 0 ? {} : Me(e, s), [o.current, s]), d = Or(n), x = (y) => Er(y, s);
  return dt(() => {
    Object.entries(a).forEach(([y, f]) => {
      nr(f) && "value" in f && t.setValue(y, f.value);
    });
  }, [t, a]), {
    fields: a,
    controlled: d,
    registerControlled: x,
    ...t
  };
}, Dr = (e) => {
  const r = fe(), { register: t, fields: s } = r, n = Ne(() => e ? Me(e, t, s) : s, [JSON.stringify(e), JSON.stringify(s), t]);
  return {
    ...r,
    fields: n
  };
}, Br = (e) => e === "Required" ? "" : e, Tr = (e) => ({
  note: e ? Br(e.message) : "",
  status: e ? "error" : void 0
});
var E = /* @__PURE__ */ ((e) => (e.Checkbox = "Checkbox", e.CheckboxGroup = "CheckboxGroup", e.CurrencyPickerField = "CurrencyPickerField", e.DateField = "DateField", e.Group = "Group", e.HiddenInput = "HiddenInput", e.IntField = "IntField", e.PercentageField = "PercentageField", e.Section = "Section", e.SensitiveTextField = "SensitiveTextField", e.Select = "Select", e.SelectField = "SelectField", e.TextArea = "Textarea", e.TextField = "TextField", e.Text = "Text", e))(E || {});
function Nr({ element: e }) {
  var u;
  const r = typeof e.name == "string" ? e.name : "", t = ft(Xt), s = Array.isArray(e.value) && typeof e.value[0] == "string" ? e.value[0] : "", n = Array.isArray(e.value) && typeof e.value[1] == "string" ? e.value[1] : "", o = (u = e.currency) == null ? void 0 : u.symbol, a = n && o ? {
    ...e.currency,
    name: o,
    code: n
  } : void 0, [d, x] = Ke(s), [y, f] = Ke(a);
  return /* @__PURE__ */ V.jsx(
    zt,
    {
      ...e,
      inputNames: { amount: `${r}[0]`, currency: `${r}[1]` },
      onChange: (g) => {
        if (x(g), typeof e.onChange == "function") {
          const _ = J.isEmpty(g), I = J.isEmpty(y == null ? void 0 : y.code) && J.isEmpty(t.defaultCurrency), L = _ || I ? null : [g, (y == null ? void 0 : y.code) || t.defaultCurrency];
          e.onChange(L);
        }
      },
      onSelectCurrency: (g) => {
        if (f(g), typeof e.onChange == "function") {
          const _ = J.isEmpty(d) || J.isEmpty(g.code) ? null : [d, g.code];
          e.onChange(_);
        }
      },
      selectedCurrency: y,
      submitUnmaskedValue: !0,
      useUnmaskedValue: !0,
      value: d
    }
  );
}
function Pr({ element: e }) {
  return /* @__PURE__ */ V.jsx(sr, { children: e.type });
}
const Wr = ht(({ palette: e, spacing: r, typography: t }) => {
  var s;
  return {
    root: {
      display: "block",
      color: e.text.secondary,
      fontSize: (s = t.small) == null ? void 0 : s.fontSize,
      marginBottom: r(0.5)
    }
  };
}), Ir = ({ children: e, className: r = "" }) => {
  const t = Wr();
  return /* @__PURE__ */ V.jsx("span", { className: Yt(t.root, r), children: e });
};
function Tt(e, { formElements: r, layout: t }) {
  const s = r[e], n = t[e], o = [E.Group, E.Section], a = Array.isArray(n == null ? void 0 : n.childIds) && (n == null ? void 0 : n.childIds.length);
  return !!(o.includes(s == null ? void 0 : s.type) || a || s != null && s.groupable);
}
function Mr(e, { formElements: r }) {
  const { hidden: t, type: s } = r[e];
  return [E.HiddenInput].includes(s) || !!t;
}
function Ur(e, r) {
  const { layout: t } = r, { childIds: s } = t[e];
  return (s == null ? void 0 : s.every((n) => Mr(n, r) || Tt(n, r))) || !1;
}
function Lr(e, r) {
  const { layout: t } = r, { childIds: s } = t[e];
  return (s == null ? void 0 : s.some((n) => Tt(n, r))) || !1;
}
function Gr({ children: e, element: r, formConfig: t }) {
  var f;
  const { layout: s } = t, { id: n } = r, o = ((f = s[n]) == null ? void 0 : f.childIds) || [], a = typeof r.label == "string" ? r.label : "", d = Ur(n, t), x = d || Lr(n, t), y = /* @__PURE__ */ V.jsx(me, { columnGap: x ? 1.25 : 1, display: "flex", flexDirection: d ? "column" : "row", rowGap: 1, children: e });
  return (!o || o.length < 1) && console.error(`An empty group with the id: "${n}" was found in your form layout.`), a ? /* @__PURE__ */ V.jsxs("label", { children: [
    /* @__PURE__ */ V.jsx(Ir, { children: a }),
    y
  ] }) : y;
}
function $r({ element: e }) {
  const { type: r, ...t } = e;
  return /* @__PURE__ */ V.jsx("input", { type: "hidden", ...t });
}
function Hr({ element: e }) {
  return /* @__PURE__ */ V.jsx(Pe, { ...e, width: 2 });
}
function qr({ element: e }) {
  const { note: r } = e;
  return /* @__PURE__ */ V.jsx(
    Pe,
    {
      ...e,
      note: /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        /* @__PURE__ */ V.jsx(
          me,
          {
            sx: {
              color: "gray.700",
              display: "inline-block",
              fontWeight: "fontWeightRegular",
              marginLeft: 0.5,
              marginRight: 1.5,
              verticalAlign: "baseline"
            },
            children: "%"
          }
        ),
        r
      ] }),
      width: 2
    }
  );
}
const Kr = ht(({ palette: e, spacing: r }) => ({
  root: {
    borderBottom: `1px solid ${e.gray[300]}`,
    marginBottom: r(2),
    width: "100%",
    "&:last-child": {
      borderBottom: "none",
      marginBottom: 0,
      "& $children": {
        paddingBottom: 0
      }
    }
  },
  children: {
    paddingBottom: r(2.5)
  }
})), Jr = (e) => {
  const { children: r, icon: t, label: s, subLabel: n, ...o } = e, a = Kr();
  return /* @__PURE__ */ V.jsxs(me, { ...o, className: a.root, children: [
    s && /* @__PURE__ */ V.jsx(Qt, { icon: t, label: s, subtitle: n }),
    r ? /* @__PURE__ */ V.jsx("div", { className: a.children, children: r }) : null
  ] });
};
function zr({ children: e, element: r, formConfig: t }) {
  var y;
  const { id: s } = r, { layout: n } = t, o = ((y = n[s]) == null ? void 0 : y.childIds) || [], a = typeof r.icon == "object" && yt(r.icon) ? r.icon : void 0, d = typeof r.label == "string" ? r.label : void 0, x = typeof r.subLabel == "string" ? r.subLabel : void 0;
  return /* @__PURE__ */ V.jsx(Jr, { icon: a, label: d, subLabel: x, children: o.length ? /* @__PURE__ */ V.jsx(me, { display: "flex", flexDirection: "column", rowGap: 2, children: e }) : null });
}
function Ue(e) {
  return ((s) => typeof s == "number" || typeof s == "string" && typeof JSON.parse(s) == "number")(e) ? {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    100: 100
  }[e] : void 0;
}
function ut({ element: e }) {
  const { onChange: r, type: t, width: s, ...n } = e, o = Ue(s), d = o || 5;
  return /* @__PURE__ */ V.jsx(
    Zt,
    {
      onChange: (x) => {
        var y;
        typeof r == "function" && r(typeof ((y = x.target) == null ? void 0 : y.value) > "u" ? null : x.target.value);
      },
      width: d,
      ...n
    }
  );
}
function Xr({ element: e }) {
  var n;
  const r = (n = e.sensitive) == null ? void 0 : n.value, t = e["data-secure-field-type"], s = J.omit(e, ["className", "sensitive", "token", "type", "validation"]);
  return /* @__PURE__ */ V.jsx(tr, { fieldType: t, sensitiveValue: r, width: 4, ...s });
}
function Yr({ element: e }) {
  const { id: r, type: t, width: s, ...n } = e, o = Ue(s);
  return /* @__PURE__ */ gt(er, { ...n, key: r, minRows: 3, width: o || 10 });
}
function Qr({ element: e }) {
  const { id: r, type: t, width: s, ...n } = e, o = Ue(s);
  return /* @__PURE__ */ V.jsx(Pe, { ...n, width: o || 4 });
}
function Zr({ element: e }) {
  const { value: r } = e;
  if (!(typeof r == "string" || typeof r == "object" && yt(r)))
    throw new Error("Text renderer received a bad setting for `value`.");
  return /* @__PURE__ */ V.jsx(bt, { children: r });
}
function Re(e) {
  return ({ element: r }) => /* @__PURE__ */ gt(e, { ...r, key: r.id });
}
const es = {
  [E.Checkbox]: Re(Kt),
  [E.CheckboxGroup]: Re(Jt),
  [E.CurrencyPickerField]: Nr,
  [E.DateField]: Re(rr),
  [E.Group]: Gr,
  [E.HiddenInput]: $r,
  [E.IntField]: Hr,
  [E.PercentageField]: qr,
  [E.Section]: zr,
  [E.Select]: ut,
  [E.SelectField]: ut,
  [E.TextArea]: Yr,
  [E.TextField]: Qr,
  [E.Text]: Zr,
  [E.SensitiveTextField]: Xr
};
function ts(e) {
  return es[e];
}
function rs(e, r, t) {
  let s = t;
  if (typeof r.getRenderer == "function") {
    const n = r.getRenderer(e);
    typeof n == "function" && (s = n);
  }
  return s;
}
function ss(e) {
  return Object.values(E).includes(e);
}
function Le(e, r) {
  let t = ss(e.type) ? ts(e.type) : void 0;
  t || (t = Pr);
  const s = r ? rs(e, r, t) : t;
  if (!s)
    throw new Error(`Could not find renderer for type: "${e.type}".`);
  return s;
}
function ns(e, r, t) {
  const { layout: s } = r;
  return e.map((n) => s[n] ? Nt(n, r, t) : (console.error(`Could not find a item on the layout with the "id" of "${n}".`), null)) || [];
}
function Nt(e, r, t) {
  var x;
  const { formElements: s, layout: n } = r, o = s[e];
  let a = (x = n[e]) == null ? void 0 : x.childIds;
  a != null && a.includes(e) && (a = a.filter((y) => y !== e), console.error(`A parent layout item cannot reference itself as a child. Looking at you "${e}" 👀.`));
  const d = Le(o, t);
  return /* @__PURE__ */ V.jsx(d, { "data-layout-id": e, element: o, formConfig: r, renderOptions: t, children: Array.isArray(a) && a.length > 0 ? ns(a, r, t) : null }, e);
}
function is(e, r) {
  return Nt("root", e, r);
}
function Is(e, r) {
  return Array.isArray(e) ? e.includes(r) : typeof e == "object" ? r in e : !1;
}
const lt = {
  xxxshort: 1,
  xxshort: 2,
  xshort: 3,
  short: 4,
  long: 5,
  xlong: 6,
  xxlong: 8,
  xxxlong: 9,
  xxxxlong: 10,
  fullWidth: 100,
  autoWidth: 100
};
function Ms(e) {
  var d, x;
  const r = J.cloneDeep(e), t = {}, s = !r.idsByToken, n = !r.idsByName;
  t.idsByToken = s ? {} : { ...r.idsByToken }, t.idsByName = n ? {} : { ...r.idsByName }, t.formElements = (d = r.formElements) == null ? void 0 : d.reduce((y, { value: f, ...u }) => {
    var g, _, I, L, K, M, D, F, w, C;
    if (Array.isArray(f) && f.length === 1 && (f = f[0]), (g = u == null ? void 0 : u.className) != null && g.includes("Width") || (_ = u == null ? void 0 : u.className) != null && _.includes("long") || (I = u == null ? void 0 : u.className) != null && I.includes("short")) {
      const B = u.className.split(" ");
      let N = 0;
      for (; N < B.length; ) {
        if (lt[B[N]]) {
          u.width = lt[B[N]];
          break;
        }
        N += 1;
      }
    }
    return ((L = r.layout[u.id]) == null ? void 0 : L.type) === "CheckboxGroup" && (f = (K = u.items) == null ? void 0 : K.reduce((B, N) => (N.checked === !0 && (B.push(N.value), delete N.checked), B), [])), ((M = r.layout[u.name]) == null ? void 0 : M.type) === "Checkbox" && (f = !!(u != null && u.checked), delete u.checked), ((D = r.layout[u.name]) == null ? void 0 : D.type) === "SensitiveTextField" && (f = void 0), ((F = r.layout[u.name]) == null ? void 0 : F.type) === "CurrencyPickerField" && (f = J.isEmpty(u.amount) || J.isEmpty(u.currency) ? void 0 : [u.amount, u.currency.code]), ((w = r.layout[u.name]) == null ? void 0 : w.type) === "PercentageField" && u.note === "%" && delete u.note, ["SelectField", "Select"].includes((C = r.layout[u.name]) == null ? void 0 : C.type) && Array.isArray(f) && !u.canSelectMultiple && (f = f[0]), u.name && (u = { ...u, name: u.name.replace(/\[\d*\]/, "") }, n && (t.idsByName[u.name] = u.id)), y[u.id] = { ...u, defaultValue: f }, s && u.token && (t.idsByToken[u.token] = u.id), y;
  }, {});
  const o = (x = r.formElements) == null ? void 0 : x.reduce((y, f) => (y[f.name] && console.log(`collision for ${f.name}, id: ${f.id}`), y[f.name] = { ...f }, y), {}), a = Object.values(r.layout);
  return t.layout = a == null ? void 0 : a.reduce((y, f) => {
    var g;
    let u = f.key === "root" ? "root" : (g = o[f.key]) == null ? void 0 : g.id;
    return (!u || u === "root") && (u = f.key, t.formElements[u] || (t.formElements[u] = f.settings), s && f.settings.token && (t.idsByToken[f.settings.token] = u), u === "root" && (t.formElements[u].id = "root")), y[u] = { id: u, childIds: [] }, f.childKeys.length > 0 && (y[u].childIds = f.childKeys.reduce((_, I) => {
      var L, K;
      return ((L = o[I]) == null ? void 0 : L.id) === u || I === u || _.push(((K = o[I]) == null ? void 0 : K.id) || I), _;
    }, []), y[u].childIds.forEach((_) => {
      y[_] && (y[_].parentId = u);
    })), f.type && (t.formElements[u].type = f.type), y;
  }, {}), t;
}
const Pt = qt({});
function os(e, r, t) {
  const { formState: s, fields: n } = e, { errors: o } = s;
  let a = n[t], d = pt(o, t) ? o[t] : void 0;
  return typeof r == "function" && (d = r(t, s)), d && (a = { ...a, ...Tr(d || o[t]) }), a.isControlled || (a = { ...a, ...e.register(t, a.rules) }), a;
}
function as({ children: e, element: r, formConfig: t }) {
  const s = Dr(), { getErrorState: n, getRenderer: o } = ft(Pt) || {}, { name: a } = r;
  if (typeof a != "string" || !pt(s.fields, a))
    throw new Error(
      `There is a problem with your configuration. An item with the name of "${a}" has not been registered with the provided form controller.`
    );
  const d = os(s, n, a);
  return s.controlled((x) => {
    const y = Le(r, { getRenderer: o });
    if (typeof y != "function")
      throw new Error(`Could not find a renderer for your form element with the name ${a} and type ${r.type}`);
    return /* @__PURE__ */ V.jsx(y, { element: { ...x, ...r }, formConfig: t, children: e });
  }, d);
}
const cs = (e) => typeof e.name == "string";
function Us(e, r, t = {}) {
  return /* @__PURE__ */ V.jsx(or, { ...r, children: /* @__PURE__ */ V.jsx(Pt.Provider, { value: t, children: is(e, {
    getRenderer: (s) => cs(s) ? as : Le(s, t)
  }) }) });
}
function us(e) {
  return typeof e.name == "string";
}
function ls(e) {
  return Object.values(e).filter(us);
}
function Ls(e = {}) {
  const r = Ne(() => ls(e) || [], [e]);
  return Rr(r);
}
function Wt(e, r) {
  const { watch: t } = e;
  dt(() => {
    const s = t((n, { name: o, type: a }) => {
      o && !Array.isArray(o) && a === "change" && setTimeout(() => {
        const d = n;
        r(o, d[o], d);
      });
    });
    return () => s.unsubscribe();
  }, [r, t]);
}
function It(e, r) {
  const t = Object.entries(e.idsByToken).reduce((s, [n, o]) => (s[o] = n, s), {});
  return Object.entries(r).reduce((s, [n, o]) => {
    const a = t[n];
    return a && (s[a] = o), s;
  }, {});
}
function Gs(e, r, t) {
  Wt(r, (s, n, o) => {
    if (!t)
      return;
    const { formElements: a = {} } = t, { token: d } = a[s] || {};
    d && e(d, n, It(t, o));
  });
}
function $s(e, r, t) {
  Wt(r, (s, n, o) => {
    if (!t)
      return;
    const { formElements: a = {} } = t, d = Object.values(a).find((x) => x.name === s);
    d && e(d, n, It(t, o));
  });
}
const Hs = {
  layout: {
    root: { id: "root" }
  },
  formElements: {
    root: { id: "root", type: "group" }
  },
  idsByName: {},
  idsByToken: {}
};
export {
  Qr as A,
  Zr as B,
  lr as C,
  Pr as D,
  or as F,
  Gr as G,
  Bs as H,
  Hr as I,
  qr as P,
  zr as S,
  Yr as T,
  Ds as X,
  Ts as Y,
  Dr as a,
  ur as b,
  Ws as c,
  cr as d,
  Ps as e,
  Tr as f,
  jr as g,
  Vr as h,
  Ls as i,
  Wt as j,
  Gs as k,
  $s as l,
  Ns as m,
  Hs as n,
  E as o,
  is as p,
  Le as q,
  Us as r,
  Is as s,
  Ms as t,
  Rr as u,
  Ue as v,
  Nr as w,
  $r as x,
  ut as y,
  Xr as z
};
//# sourceMappingURL=constants-0Q39_oHZ.mjs.map
